import { render, staticRenderFns } from "./ExchangeBox.vue?vue&type=template&id=99bbd4c0&scoped=true"
import script from "./ExchangeBox.vue?vue&type=script&lang=js"
export * from "./ExchangeBox.vue?vue&type=script&lang=js"
import style0 from "./ExchangeBox.vue?vue&type=style&index=0&id=99bbd4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bbd4c0",
  null
  
)

export default component.exports